import React from 'react'

function TotalUsers({nbuser}) {
  return (
    <div className="col-md-6 col-xl-3 mb-4">
        <div className="card shadow border-start-primary py-2">
            <div className="card-body">
                <div className="row align-items-center no-gutters">
                    <div className="col me-2">
                        <div className="text-uppercase text-primary fw-bold text-xs mb-1"><span>Nombre d'utilisateurs</span></div>
                        <div className="text-dark fw-bold h5 mb-0"><span>{nbuser?nbuser:0}</span></div>
                    </div>
                    <div className="col-auto"><i className="fas fa-people-carry fa-2x text-gray-300"></i></div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default TotalUsers